import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
//add user form start
registerForm: FormGroup;
submitted = false;
router: any;
  constructor(public fb: FormBuilder, private http: HttpClient, private _router: Router) {
    this.registerForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    })
   }

   get f() { return this.registerForm.controls; }

    submitForm() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.registerForm.invalid) {
          return;
      }

      if((this.registerForm.value.username == 'aqar_20_21') && (this.registerForm.value.password == 'Rg!@#321')){
        this._router.navigateByUrl('/aqar');
      }else{
        this._router.navigateByUrl('/login');
      }

    } //submit form

  ngOnInit(): void {
  }

}
